import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TemporaryProductIdService {
  private readonly prefix = 'tmp-product-id';

  generate(): string {
    return `${this.prefix}-${new Date().getTime()}-${Math.random()}`;
  }

  isTemporaryProductId(id: string): boolean {
    return new RegExp(`^${this.prefix}`, 'i').test(id);
  }
}
